<script setup lang="ts">

const {t} = useI18n()

// Приймаємо пропси
const props = defineProps<{
  modelValue: boolean; // Для v-model
}>()

// Емітуємо події
const emit = defineEmits(['update:modelValue'])

// Локальна обчислювана властивість для v-model
const snackbar = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
})

// Оновлення сторінки зі спробою зберегти стан. force — бо без нього reloadNuxtApp мовчки
// ігнорує виклик, якщо цей шлях уже перезавантажувався менш ніж 10 с тому (захист Nuxt від
// циклів), і кнопка «Оновити» виглядала б мертвою. Service worker тут ні до чого: з
// skipWaiting він активується сам і версію застосунку не тримає (див. nuxt.config).
const reload = () => {
  reloadNuxtApp({persistState: true, force: true})
}
</script>

<template>
  <v-snackbar v-model="snackbar" color="primary" timeout="-1">
    <b>{{ t('updateNotification.title') }}</b><br />
    {{ t('updateNotification.text') }}
    <template v-slot:actions>
      <v-btn @click="reload">{{ t('buttons.refresh') }}</v-btn>
    </template>
  </v-snackbar>
</template>
